import { useCallback, useEffect, useState, } from 'react';
import { differenceInSeconds, addSeconds, } from 'date-fns';
import { usePlaybackStateStore } from '@annunciate/core';
const { setSleepTime } = usePlaybackStateStore.getState();
export const useSleepTimer = () => {
    const sleepTime = usePlaybackStateStore(state => state.sleepTime);
    const [seconds, setSeconds] = useState(0);
    const tickHoursAndMinutes = useCallback(() => {
        if (sleepTime) {
            const now = Date.now();
            const diffS = differenceInSeconds(sleepTime, now);
            if (diffS <= 0) {
                setSeconds(0);
            }
            else {
                setSeconds(diffS);
            }
        }
        else {
            setSeconds(0);
        }
    }, [sleepTime?.toISOString()]);
    const addSecondsToTime = useCallback((seconds) => {
        const marginOfErrorSeconds = (2 * 1000);
        const now = Date.now();
        const updated = addSeconds(sleepTime || now, seconds);
        if (updated.getTime() <= now + marginOfErrorSeconds) {
            setSleepTime();
        }
        else {
            setSleepTime(updated);
        }
    }, [sleepTime?.toISOString()]);
    useEffect(() => {
        tickHoursAndMinutes();
        const timer = setInterval(() => {
            tickHoursAndMinutes();
        }, 1000);
        return () => clearInterval(timer);
    }, [sleepTime?.toISOString()]);
    const roundMinSecs = Math.ceil(seconds / 60) * 60;
    const hrsMax = Math.floor(roundMinSecs / 60 / 60);
    const minsMax = (Math.floor(roundMinSecs / 60) - (hrsMax * 60));
    const hrs = Math.floor(seconds / 60 / 60);
    const mins = (Math.floor(seconds / 60) - (hrs * 60));
    const secs = (seconds - (hrs * 60 * 60) - (mins * 60));
    return {
        sleepTime,
        setSleepTime,
        addSecondsToTime,
        roundMinSecs,
        hrsMax,
        minsMax,
        hrs,
        mins,
        secs,
    };
};
//# sourceMappingURL=useSleepTimer.js.map